import './GridView.scss';

import { FC } from 'react';
import { Card } from 'src/components';
import { tHouseSmall } from 'src/types';

interface IProps {
    municipality?: string;
    reNFT?: boolean;
    items: tHouseSmall[] | [];
}
export const GridView: FC<IProps> = ({ municipality, items, reNFT }) => {
    return (
        <div className="grid">
            {items.length > 0 &&
                items.map((el, id) => {
                    return (
                        <div key={`card-${el.id}-${id}`} className="grid__item">
                            <Card municipality_slug={municipality} item={el} reNFT={reNFT} />
                        </div>
                    );
                })}
        </div>
    );
};
